import React from 'react';
import { Box, Container, Divider, Grid, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { CallUsCard, EmailUsCard, SubmitRequestCard } from './help-center-contact-cards';
import { HelpCenterBanner } from './help-center-banner';
import { HelpCenterTile, HelpfulLinksSection } from './helpful-links-section';
import { useHelpCenterStyles } from './support-page-styles';

export type { HelpCenterTile };

export type HelpCenterContainerProps = {
  tiles: HelpCenterTile[];
  helpCenterUrl: string;
  title?: string;
  subtitle?: string;
};

export const HelpCenterContainer: React.VFC<HelpCenterContainerProps> = ({ tiles, helpCenterUrl, title, subtitle }) => {
  const { classes } = useHelpCenterStyles();
  const l10n = useL10n();

  return (
    <Container className={classes.helpCenterContainer}>
      {title && (
        <Box className={classes.pageHeader}>
          <Typography variant="h3" className={classes.pageTitle}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body1" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </Box>
      )}

      <HelpfulLinksSection tiles={tiles} />

      <HelpCenterBanner helpCenterUrl={helpCenterUrl} />

      <Divider />

      <Box>
        <Typography variant="h6" className={classes.sectionHeading}>
          {l10n.support.stillNeedHelp}
        </Typography>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }}>
            <SubmitRequestCard />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <CallUsCard />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <EmailUsCard />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
